import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["toggle"]
    declare readonly toggleTarget: HTMLInputElement

    connect() {
        document.addEventListener("turbo:before-visit", this.close.bind(this))
    }

    disconnect() {
        document.removeEventListener("turbo:before-visit", this.close.bind(this))
    }

    close() {
        if (this.hasToggleTarget) {
            this.toggleTarget.checked = false
        }
    }
}
